import { type ReactElement } from 'react';
import { NeonButton, NeonCardStandard } from '@ps-refarch-ux/neon';
import {
  DATA_SLOT,
  NEON_ADD_DOCUMENT_ILLUSTRATION,
  NEON_GRID_CONTAINER_CLASS,
  NEON_TEXT,
  NeonButtonTypes,
  NeonGridColumn,
  NeonIllustrationBackground,
} from '@/constants/neon-constants';
import {
  EMPTY_PLANS_OF_STUDY_BODY_STYLE,
  EMPTY_PLANS_OF_STUDY_CARD_STYLE,
  EMPTY_PLANS_OF_STUDY_ILLUSTRATION_STYLE,
  EMPTY_PLANS_OF_STUDY_TITLE_STYLE,
} from './empty-plans-of-study.styles';
import {
  EMPTY_PLAN_OF_STUDY_ID,
  EMPTY_PLAN_OF_STUDY_TEXT,
} from '@/constants/plan-of-study-constants';
import { NeonIllustrations } from '@/components/NeonIllustration/neon-illustration';

type EmptyPlansOfStudyProps = {
  onCreatePlanOfStudy?: () => void;
};

export const EmptyPlansOfStudy = ({
  onCreatePlanOfStudy,
}: EmptyPlansOfStudyProps): ReactElement => {
  return (
    <NeonCardStandard dataInjectionSpacing="false">
      <div data-slot={DATA_SLOT} style={EMPTY_PLANS_OF_STUDY_CARD_STYLE}>
        <NeonIllustrations
          dataBackground={NeonIllustrationBackground.Complex}
          dataIllustration={NEON_ADD_DOCUMENT_ILLUSTRATION.AddDocument}
          containerClassName={NEON_GRID_CONTAINER_CLASS.GridContainer}
          columnClassName={`${NeonGridColumn.Two} ${NeonGridColumn.MediumFour} ${NeonGridColumn.LargeFour}`}
          illustrationStyle={EMPTY_PLANS_OF_STUDY_ILLUSTRATION_STYLE}
        />
        <p className={NEON_TEXT} style={EMPTY_PLANS_OF_STUDY_TITLE_STYLE}>
          {EMPTY_PLAN_OF_STUDY_TEXT.Title}
        </p>
        <p className={NEON_TEXT} style={EMPTY_PLANS_OF_STUDY_BODY_STYLE}>
          {EMPTY_PLAN_OF_STUDY_TEXT.Body}
        </p>
        {onCreatePlanOfStudy && (
          <NeonButton
            id={EMPTY_PLAN_OF_STUDY_ID.Button}
            dataType={NeonButtonTypes.Primary}
            dataText={EMPTY_PLAN_OF_STUDY_TEXT.Button}
            dataIcon="add"
            onClick={onCreatePlanOfStudy}
          />
        )}
      </div>
    </NeonCardStandard>
  );
};
